import React from 'react'
import PropTypes from 'prop-types'
import {Heading, Stack, Text} from '@chakra-ui/react'
import PaymentRegistrationFields from '/overrides/app/components/forms/payment-registration-fields'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

const GuestAccountCreation = ({registerForm, onRegisterCustomer}) => {
    const {tSubscriptions} = useTranslationHelpers()
    return (
        <>
            <Heading fontSize="lg">
                <Text as="span" fontWeight="bold" color="black">
                    {tSubscriptions?.freeReturnsTitle}
                </Text>
                <Text as="span" fontWeight="normal" color="black">
                    {' '}
                    {tSubscriptions?.freeReturnsTitleNote}
                </Text>
            </Heading>

            <form onSubmit={registerForm.handleSubmit(onRegisterCustomer)}>
                <Stack>
                    <PaymentRegistrationFields form={registerForm} />
                </Stack>
            </form>
        </>
    )
}

GuestAccountCreation.propTypes = {
    registerForm: PropTypes.object.isRequired,
    onRegisterCustomer: PropTypes.func.isRequired
}

export default GuestAccountCreation
